<template>
  <ModalDialog
    ref="dialog"
    title="Send Invoice"
    :submitting="submitting"
    :scrollable="true"
    :submitDisabled="currentlyUploading"
    submitTitle="Send Invoice"
    icon="fa-envelope-open-text"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm">
      <EmailMessageForm 
        :contactId="contactId"
        :templateType="MessageTemplateTypes.invoice"
        :messageTemplateUpdateFn="messageTemplateUpdateFn"
        :previewLink="previewLink"
        :defaultCCList="defaultCCList"
        @uploading="currentlyUploading = $event"
        @update="emailDetails = $event"
      />
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'
import EmailMessageForm from '@/modules/core/components/emailMessageForm'

import { MessageTemplateTypes } from '@/store/types'

export default {
  name: 'SendInvoiceDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
    EmailMessageForm
  },
  props: {
    contactId: Number,
    invoiceId: Number,
    customContactEmail: String
  },
  data() {
    return {
      dialogForm: {},
      emailDetails: { },
      submitting: false,
      currentlyUploading: false,

      messageTemplateUpdateFn: this.getMessageTemplateUpdatePromise,
    }
  },
  created() {
    this.MessageTemplateTypes = MessageTemplateTypes
  },
  mounted() {
  },
  computed: {
    previewLink() {
      return `/accounts/invoices/${this.invoiceId}/report`
    },
    defaultCCList() {
      if(this.customContactEmail && this.customContactEmail != '')
        return [this.customContactEmail]
      return []
    }
  },
  methods: {
    show() {
      // Reset form
      this.responseInfo = { }
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var invoiceEmailData = {
        messageSubject: this.emailDetails.messageSubject,
        messageContent: this.emailDetails.messageContent,
        emailPersonList: this.emailDetails.contactPersonList.map(person => { return { contactPersonId: person.id } }),
        uploadFileList: this.emailDetails.uploadFileList,
        ccList: this.emailDetails.ccList
      }

      this.$apiService.accountsService.sendInvoiceEmail(this.invoiceId, invoiceEmailData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    },
    getMessageTemplateUpdatePromise(messageTemplateId) {
      return new Promise((resolve, reject) => {
        return this.$apiService.accountsService.getInvoiceSendInvoiceTemplate(this.invoiceId, messageTemplateId)
        .then(response => {
          return resolve(response.data)
        })
        .catch(err => { reject(err) })
      })
    }
  }
}
</script>